import { DEFAULT_TOTAL_RECORDS } from "utils/constants";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchAppointmentCancellations = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS,
) => {
  return axiosInstance.get(EndPoints.APPOINTMENT_CANCELLATIONS.LIST, {
    params: {
      limit,
      page_no,
      zone_id,
      ...filter,
      // total_count:totalItems
    },
  });
};

export const fetchAppointmentCancellationDetail = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS,
) => {
  return axiosInstance.get(EndPoints.APPOINTMENT_CANCELLATIONS.DETAIL, {
    params: {
      limit,
      page_no,
      zone_id,
      ...filter,
      // total_count:totalItems
    },
  });
};

export const createBranch = (payload) => {
  return axiosInstance.post(
    EndPoints.APPOINTMENT_CANCELLATIONS.CREATE,
    payload,
  );
};

export const updateBranch = (payload) => {
  return axiosInstance.put(EndPoints.APPOINTMENT_CANCELLATIONS.UPDATE, payload);
};

export const deleteBranch = (payload) => {
  const url = EndPoints.APPOINTMENT_CANCELLATIONS.DELETE + `/${payload}`;
  return axiosInstance.delete(url);
};

export const downloadCSV = () => {
  return axiosInstance.put(EndPoints.APPOINTMENT_CANCELLATIONS.DOWNLOAD_CSV, {
    responseType: "blob",
  });
};
